import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function imgUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${API}/images/${path}`;
}

export function money(n) {
  if (n == null) return "";
  return "$" + Number(n).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " CAD";
}

export const METALS = [
  { id: "silver", label: "Silver" },
  { id: "14k", label: "14K Gold" },
  { id: "18k", label: "18K Gold" },
];
export const CARATS = [1, 2, 3, 4, 5];
export const SHAPES = ["Round", "Oval", "Pear", "Emerald", "Radiant", "Heart", "Marquise", "Princess", "Cushion", "Square", "Asscher"];

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const SWATCH = {
  Gold: "#D4AF37",
  "Rose Gold": "#B76E79",
  Silver: "#C0C0C0",
};
